export { default } from "./InvitePage";
export const INVITE_PATH = "/invite";
